import { useEffect } from 'react';

type Pagination = {
  hasNext: boolean;
  isLoadingNext: boolean;
  loadNext: (count: number) => unknown;
};

/**
 * Follows a connection to its end, a page at a time, and says when it got
 * there.
 *
 * For a list whose meaning is its whole extent -- a twelve-week chart drawn
 * from a truncated window is a trend that is wrong, not one that is short.
 * The server caps a page at 100 (`MAX_PAGE_SIZE`), so a heavy learner's
 * window can only ever arrive in several.
 */
export function useWholeConnection({ hasNext, isLoadingNext, loadNext }: Pagination, pageSize: number): boolean {
  useEffect(() => {
    if (hasNext && !isLoadingNext) loadNext(pageSize);
  }, [hasNext, isLoadingNext, loadNext, pageSize]);
  return !hasNext;
}
